import React from 'react';
import PropTypes from 'prop-types';
import {
  RadioContainer, Input, Text, SubLabel,
} from './css';

const RadioButton = ({
  input,
  options,
  disabled,
  checkPayment,
}) => (
  <>
    {options.map((option, index) => (
      <RadioContainer key={index}>
        <Input
          {...input}
          type="radio"
          value={option.value}
          disabled={disabled}
          checked={checkPayment ? checkPayment === option.value : input.value === option.value}
          onChange={(value) => input.onChange(value)}
        />
        <Text disabled={disabled}>{option.label}</Text>
        {option.subLabel && (
          <SubLabel disabled={disabled}>{option.subLabel}</SubLabel>
        )}
      </RadioContainer>
    ))}
  </>
);

RadioButton.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      subLabel: PropTypes.string,
      defaultChecked: PropTypes.bool,
    }),
  ),
  disabled: PropTypes.bool,
  checkPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RadioButton;
